import { lazy } from "react";
import { Route } from "react-router-dom";
import { PartnerProtectedRoute } from "./PartnerProtectedRoute";
import { PartnerLayout } from "./PartnerLayout";

// All partner-portal routes live behind /partner/* and are irrelevant to the
// public marketing pages. Grouping them here keeps the partner code out of
// App.tsx's main bundle parse — the partner chunk only loads when a partner
// URL is visited.
const PartnerLogin = lazy(() => import("@/pages/partner/PartnerLogin"));
const PartnerSignup = lazy(() => import("@/pages/partner/PartnerSignup"));
const PartnerForgotPassword = lazy(() => import("@/pages/partner/PartnerForgotPassword"));
const PartnerResetPassword = lazy(() => import("@/pages/partner/PartnerResetPassword"));
const PartnerCompleteApplication = lazy(() => import("@/pages/partner/PartnerCompleteApplication"));
const PartnerDashboard = lazy(() => import("@/pages/partner/PartnerDashboard"));
const PartnerSubmitLead = lazy(() => import("@/pages/partner/PartnerSubmitLead"));
const PartnerLeads = lazy(() => import("@/pages/partner/PartnerLeads"));
const PartnerPayments = lazy(() => import("@/pages/partner/PartnerPayments"));
const PartnerAgreement = lazy(() => import("@/pages/partner/PartnerAgreement"));
const PartnerProfile = lazy(() => import("@/pages/partner/PartnerProfile"));

// Exported as raw <Route> children so React Router matches them directly.
export const partnerRouteElements = (
  <>
    <Route path="/partner/login" element={<PartnerLogin />} />
    <Route path="/partner/signup" element={<PartnerSignup />} />
    <Route path="/partner/forgot-password" element={<PartnerForgotPassword />} />
    <Route path="/partner/reset-password" element={<PartnerResetPassword />} />
    <Route path="/partner/complete-application" element={<PartnerCompleteApplication />} />
    <Route path="/partner" element={<PartnerProtectedRoute><PartnerLayout /></PartnerProtectedRoute>}>
      <Route path="dashboard" element={<PartnerDashboard />} />
      <Route path="submit-lead" element={<PartnerSubmitLead />} />
      <Route path="leads" element={<PartnerLeads />} />
      <Route path="payments" element={<PartnerPayments />} />
      <Route path="agreement" element={<PartnerAgreement />} />
      <Route path="profile" element={<PartnerProfile />} />
    </Route>
  </>
);
